// @flow

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import Select from 'react-select';
import { colors } from '@components/ListItemFacility/styles';
import SearchThin from '@images/svg/search-thin.svg';

export const StyledBox = styled.div`
  width: 100%;
  height: 100vh;
  top: 50px;
  right: 0;
  position: fixed;
  padding: 2px;
  background: rgba(0, 0, 0, 0.8);
  ${breakpoint('desktop')`
        top: 80px;
        right: 0;
  `}
`;

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  width: 25%;
  margin-right: 40px;
  border-radius: 8px;
  z-index: 200;

  ${breakpoint('mobile', 'desktop')`
    width: 80%;
    margin: auto;
  `}
`;


export const StyledSelect = styled(Select)`
  cursor: pointer;
  .css-26l3qy-menu {
    z-index: 200 !important;
  }
  .css-qc6sy-singleValue {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
  }
  .css-1s2u09g-control {
    cursor: pointer;
    height: 48px !important;

    ${breakpoint('mobile', 'desktop')`
        height: 40px !important;
        border-radius: 8px;
  `}
    ${({ bgwhite }) => !bgwhite && ' background-color: white !important; '}
  }
  .css-1s2u09g-control {
    border: 1px solid ${colors.translucentDarkBlue} !important;
    ${({ noBorder }) => noBorder && 'border: none !important'};
    ${breakpoint('mobile', 'desktop')`
      border-radius: 8px;
    `}
    ${breakpoint('desktop')`
      border-radius: 8px;
    `}
  }
  .css-1pahdxg-control {
    border-color: ${colors.translucentDarkBlue} !important;
    ${({ noBorder }) => noBorder && 'border: none !important'};
    ${breakpoint('mobile', 'desktop')`
      border-radius: 8px;
    `}
  }
  .css-1pahdxg-control {
    border-color: ${colors.translucentDarkBlue} !important;
    ${({ bgwhite }) =>
    !bgwhite
      && `
      background-color: ${colors.white} !important;
    `}
    height: 48px !important;
    ${breakpoint('mobile', 'desktop')`
        height: 30px !important;
  `}
  }

  .css-yrduhn-placeholder {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 16px;

    ${breakpoint('mobile', 'desktop')`
      font-size: 12px; 
    `}
  }

  .css-1pahdxg-control {
    box-shadow: none !important;
  }
  .css-1okebmr-indicatorSeparator {
    display: none;
  }
  .css-1hb7zxy-IndicatorsContainer {
    display: none !important;
  }
`;

export const SearchIcon = styled(SearchThin)`
  height: 25px;
  width: 25px;
  margin-left: 15px;
  position: absolute;
  z-index: 10;
  top: calc((100% - 25px) / 2);
  left: 0;

  ${breakpoint('mobile', 'desktop')`
  height: 20px;
  width: 20px;
  top: calc((100% - 20px) / 2);
  `}
`;

export const StyledSearchWrapper = styled.div`
  position: relative;
  flex: 1;
  transition: all 0.3s;
  border-radius: 8px;

  ${breakpoint('mobile', 'desktop')`
    margin: auto;
  `}
`;

export const StyledCustomIcon = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    height: 30px;
    width: 30px;
    margin-right: 16px;
  }

  span {
    font-size: 16px;
    line-height: 1.2;
    font-weight: 600;
    color: ${colors.navyGray};
  }

  ${breakpoint('mobile', 'desktop')`
      img {
    height: 15px;
    width: 15px;
    margin-right: 16px;
  }

  span {
    font-size: 12px;
    line-height: 1.2;
    font-weight: 600;
    color: ${colors.navyGray};
  }
   `}
`;

export const StyledOuter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
